import { cn } from '@talentmesh/ui/lib/utils';
import React, { ReactNode } from 'react';

/** h-22 in tailwind */
export const TOP_BAR_HEIGHT = 88;

export interface PageProps {
    topBar?: ReactNode;
    topBarHeight?: string;
    hideMargin?: boolean;
    header?: ReactNode;
    pageContainerProps?: React.HTMLAttributes<HTMLDivElement>;
    pageContentContainerProps?: React.HTMLAttributes<HTMLDivElement> & { ref?: React.RefObject<HTMLDivElement | null> };
    headerProps?: React.HTMLAttributes<HTMLDivElement>;
    containerProps?: React.HTMLAttributes<HTMLDivElement>;
    childrenProps?: React.HTMLAttributes<HTMLDivElement>;
}

/** @deprecated please use src/Components/page instead */
export const Page = ({
    children,
    topBar,
    header,
    hideMargin,
    pageContainerProps,
    pageContentContainerProps,
    headerProps,
    containerProps,
    childrenProps,
}: React.PropsWithChildren<PageProps>) => {
    return (
        <div
            data-cy="pageContainer"
            {...pageContainerProps}
            className={cn('flex flex-col', pageContainerProps?.className)}
        >
            {topBar}
            <div
                style={{ height: `calc(100vh - ${TOP_BAR_HEIGHT}px)` }}
                {...pageContentContainerProps}
                className={cn('flex flex-col overflow-y-auto', pageContentContainerProps?.className)}
                data-cy="pageContentContainer"
            >
                {header && <div {...headerProps}>{header}</div>}
                <div
                    {...containerProps}
                    className={cn('container mx-auto h-full max-w-6xl', containerProps?.className)}
                >
                    <div {...childrenProps} className={cn('flex h-full flex-col', childrenProps?.className)}>
                        {children}
                        {!hideMargin && <div className="min-h-18" />}
                    </div>
                </div>
            </div>
        </div>
    );
};
